import { makeAutoObservable } from 'mobx';

import { CollectionType } from '@/collection/entity/CollectionType';
import URLProvider from '@/common/services/URLProvider';
import type { CollectionItemModel } from '@/drive/entities/DriveItem/CollectionItem';
import { CollectionItem, DriveItemType } from '@/drive/entities/DriveItem/DriveItem';
import { DriveItemPreview } from '@/drive/entities/DriveItem/DriveItemPreview';
import { DriveItemId } from '@/drive/entities/DriveItemId';
import { DriveTreeItem } from '@/drive/entities/DriveTreeItem/DriveTreeItem';
import { GlobalAccessLevel } from '@/security/constants/GlobalAccessLevel';
import { ProjectDataAccess } from '@/security/types/DataAccess';

export class CollectionTreeItem implements DriveTreeItem {
  id!: DriveItemId;
  title!: string;

  count!: number;
  description?: string;
  preview?: Nullable<DriveItemPreview>;
  createdAt?: string;
  collectionId!: string;
  collectionType!: CollectionType;
  type!: DriveItemType.Collection;
  access!: GlobalAccessLevel;
  dataAccess!: ProjectDataAccess;
  canEdit!: boolean;
  canManageAccess!: boolean;
  children?: undefined;

  collapsed: boolean;

  constructor(item: CollectionItemModel | CollectionItem, collapsed = true) {
    makeAutoObservable(this, {
      id: false,
      count: false,
      description: false,
      preview: false,
      createdAt: false,
      collectionId: false,
      collectionType: false,
      type: false,
      access: false,
      dataAccess: false,
      canEdit: false,
      canManageAccess: false,
      children: false,
    });

    Object.assign(this, item);
    this.collapsed = collapsed;
  }

  setTitle(title: string) {
    this.title = title;
  }

  getUrl() {
    return URLProvider.collectionDetailPage({ id: this.collectionId });
  }

  getDriveId() {
    return this.id;
  }

  getAccess() {
    return this.access;
  }

  toDriveItem(): CollectionItem {
    return new CollectionItem({
      id: this.id,
      type: DriveItemType.Collection,
      title: this.title,
      count: this.count,
      description: this.description,
      preview: this.preview,
      createdAt: this.createdAt,
      collectionId: this.collectionId,
      collectionType: this.collectionType,
      access: this.access,
      dataAccess: this.dataAccess,
      canEdit: this.canEdit,
      canManageAccess: this.canManageAccess,
    });
  }
}
